import {
  call,
  put,
  takeLatest,
  takeEvery
} from "redux-saga/effects";
import {
  uploadFile
} from "utils/api";
import {
  ToastSuccess,
  ToastError
} from "components/Global/Toasts/Toasty";

import {
  defaultReturn,
  makePayload,
  generateDefaultActions,
  subKeySaga,
  requestSaga,
  fillDictionary
} from "../utils/helpers";

const initialState = {
  currentCapCalcSettings: null
};

export default function capCalcSettingsReducer(state = initialState, action) {
  const { type, payload, subKey } = action;
  switch (type) {
    case GET_CURRENT_CAP_CALC_SETTINGS.success:
      return defaultReturn(state, payload.result, "currentCapCalcSettings");
    case UPDATE_CAP_CALC_SETTINGS.success:
      ToastSuccess("Settings Saved");

      return state;
    case UPDATE_CAP_CALC_SETTINGS.failure:
      ToastError("Save Failed");

      return state;
    default:
      return state;
  }
}

export function* capCalcSettingsSaga() {
  yield takeLatest(GET_CURRENT_CAP_CALC_SETTINGS.value, getCurrentCapCalcSettingsSaga);
  yield takeLatest(UPDATE_CAP_CALC_SETTINGS.value, updateCapCalcSettingsSaga);
}

// GET_CURRENT_CAP_CALC_SETTINGS
export const GET_CURRENT_CAP_CALC_SETTINGS = generateDefaultActions("GET_CURRENT_CAP_CALC_SETTINGS");
export const getCurrentCapCalcSettings = payload => makePayload(GET_CURRENT_CAP_CALC_SETTINGS.value, payload);
function* getCurrentCapCalcSettingsSaga(payload) {
  const url = "/getCapCalculatorSettings";
  yield requestSaga(GET_CURRENT_CAP_CALC_SETTINGS, url);
}

export const UPDATE_CAP_CALC_SETTINGS = generateDefaultActions("UPDATE_CAP_CALC_SETTINGS");
export const updateCapCalcSettings = payload => makePayload(UPDATE_CAP_CALC_SETTINGS.value, payload);
function* updateCapCalcSettingsSaga(payload) {
  yield requestSaga(UPDATE_CAP_CALC_SETTINGS, "/saveCapCalculatorSettings", "POST", payload);
}
